import { render, staticRenderFns } from "./CompraFinalizada.vue?vue&type=template&id=818d5502"
import script from "./CompraFinalizada.vue?vue&type=script&lang=js"
export * from "./CompraFinalizada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports